import React from "react";
import { Link } from 'react-router-dom'

const Welcome2 = () => (
    <div>
        <div className="h1-introduce">
            <div className="container">
                <div className="row">
                    <div className="col-sm-6">
                        <div className="sc-heading style-02">
                            <h3 className="title">Passez un séjour unique et mémorable à Songon Park</h3>
                            <div className="description">
                                <p>Situé à Songon-Agban, le Songon Park Hotel propose des installations de sports nautiques. Il possède une piscine extérieure, un jardin et une terrasse. L'établissement propose une réception ouverte 24h/24 et un service d'étage.</p>
                            </div>
                            <div className="head-button">
                                <Link to="/apropos" className="more-info">Lire plus</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="col">
                            <Link to="#"><img src="images/home/h1-img1.jpg" alt=""/></Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default Welcome2